<template lang="html">
  <v-alert
    dense
    text
    type="info"
    class="ma-0"
  >
    {{ message }}
  </v-alert>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    message() {
      if (this.text) return this.text;
      return this.$t('views.assigned_resources.no_assigned_resources');
    }
  }
};
</script>

<style lang="css" scoped>
</style>
